<template>

	<div>
		<v-stepper v-model="e6" vertical style="border:0;box-shadow:none;">
			<v-stepper-step

					step="1"
			>
				In your browser, while connected to the router's network, navigate to your router admin console
			</v-stepper-step>

			<v-stepper-content step="10">
				Usually: http://192.168.1.1

			</v-stepper-content>


			<v-stepper-step step="2"
			>
				Sign in to the router's console.
			</v-stepper-step>

			<v-stepper-content step="10">
				The default credentials are

				username: admin
				password: admin

			</v-stepper-content>



			<v-stepper-step step="3" >
				In the left menu, under "Advanced settings" click on WAN
			</v-stepper-step>

			<v-stepper-content step="10">
				In some cases it might be found under, "Network settings" or "Advanced settings" then "DNS"
			</v-stepper-content>

			<v-stepper-step step="4" >
				Look for "Connect to DNS Server automatically" and select "No"
			</v-stepper-step>

			<v-stepper-content step="10">



			</v-stepper-content>

			<v-stepper-step step="5" >
				Look for "DNS Server1" and "DNS Server1" and set GameEnable's DNS IPs
			</v-stepper-step>

			<v-stepper-content step="10">
				<dns-ip-list></dns-ip-list>
			</v-stepper-content>

			<v-stepper-step step="6" >
				Click "Apply"
			</v-stepper-step>

			<v-stepper-content step="10">

			</v-stepper-content>

		</v-stepper>


	</div>


</template>

<style scoped>

	>>> .v-stepper__label {
		color: rgba(0, 0, 0, 0.87)!important;
	}

</style>

<script>


import dnsIpList from '../../../../components/dnsIpsList'
  // import i18n from '@/i18n';
  // import Page from '../mixins/page'


  export default {
    title: "Setup GameEnable's DNS for ASUS",
    name: 'set-router-dns/asus',
	  data: ()=>({
		  e6:10
	  }),
	  components: {

		  dnsIpList

	  }
  };
</script>
